import React, { Component } from "react"
import { Grid, GridProps } from 'semantic-ui-react';
import styled from 'styled-components';

const GridSc = styled(Grid)`
  &.ui.grid {
    margin: 0;
  }

  &.ui.grid > *{
     padding-top: 0.5rem !important;
     padding-bottom: 0.5rem !important;
  }
`;

class PxGrid extends Component<GridProps> {

  render(): React.ReactNode {
    const {children, ...rest} = this.props;
    return (
        <GridSc {...rest}>
          {children}
        </GridSc>
    )
  }

}

export default PxGrid;
